// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__N7XeG","l1":"loader_l1__stZjQ"};